<div class="page flex h-full w-screen">
   <div class="page-header w-full">
        <h3>
            Page Not Found
        </h3>
   </div>
    <div class="page-content">
        <h3>
            Error 404: Not found
        </h3>
    </div>
</div>

